import firebase from "firebase";

var firebaseConfig = {
  apiKey: "AIzaSyAeJeyS2ugAEl69lc_VpJOrS7NXszsWkUc",
  authDomain: "musicify-4707b.firebaseapp.com",
  projectId: "musicify-4707b",
  storageBucket: "musicify-4707b.appspot.com",
  messagingSenderId: "1015875235991",
  appId: "1:1015875235991:web:028350c11ddae2eb2e39d2",
  measurementId: "G-PQLLQYLWK8",
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();
const db = firebase.firestore();
const storage = firebase.storage();

export { auth, provider, db, storage };
